// web-frontend/src/layouts/AuthLayout.jsx
/**
 * 🔐 AuthLayout - 인증 페이지 레이아웃
 * 
 * 기능:
 * - 라이트/다크 모드 지원
 * - DSK 브랜드 그라데이션 글로우 효과 (스플래시와 동일)
 * - 반응형 디자인 (모바일/태블릿/데스크톱)
 */
import React from 'react';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-layout">
      {/* 🎨 배경 레이어 */}
      <div className="auth-background">
        {/* Soft Sky 베이스 */}
        <div className="auth-bg-base" />
        
        {/* 그라데이션 글로우 효과 (스플래시와 동일) */}
        <div className="glow-primary-top-right" />
        <div className="glow-secondary-bottom-left" />
      </div>
      
      {/* 📋 중앙 컨텐츠 */}
      <div className="auth-content">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
